"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function extractIEVersion(variant, userAgent) {
    var edgeRegex = /Edge\/(\d*\.\d*)/g;
    var revisionRegex = /rv:(\d*\.\d*)/g;
    var msieRegex = /MSIE (\d*\.\d*)/g;
    var version;
    switch (variant) {
        case 'edge':
            version = edgeRegex.exec(userAgent);
            break;
        case '11':
            version = revisionRegex.exec(userAgent);
            break;
        case '10':
            version = msieRegex.exec(userAgent);
            break;
    }
    return version !== null ? version[1] : '';
}
exports.default = extractIEVersion;
//# sourceMappingURL=extractIEVersion.js.map